import { Injectable } from '@angular/core';
import { LeavePageService } from '@app/core/leave-page-handler/service/leave-page.service';
import {
  GoToStepCancel,
  GoToStepFail,
  GoToWizardStepPayload,
  UpdateStep,
  UpdateSubStep,
  WizardNavigationActionTypes
} from '@app/shared/wizard-navigation/actions/wizard-navigation';
import { WizardStep } from '@app/shared/wizard-navigation/model/wizard-step';
import { hasValue, mapPayload } from '@app/util';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import * as R from 'ramda';
import { of } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';

@Injectable()
export class WizardNavigationEffects {

  goToStep$ = createEffect(() => this.actions$.pipe(
    ofType(WizardNavigationActionTypes.GoToStep, WizardNavigationActionTypes.GoToSubStep),
    mapPayload(),
    switchMap(({step, additionalActions}: GoToWizardStepPayload) => this.leavePageService.check().pipe(
      switchMap((canActivate) => canActivate
        ? this.getActivateActions(step, additionalActions)
        : [new GoToStepCancel()]),
      catchError(error => of(new GoToStepFail(error)))
    ))
  ));

  private getActivateActions(step: WizardStep, additionalActions: Action[]): Action[] {
    const actions: Action[] = [(step.subStep ? new UpdateSubStep(step) : new UpdateStep(step))];
    return hasValue(additionalActions) ? R.concat(actions, additionalActions) : actions;
  }

  constructor(
    private actions$: Actions,
    private leavePageService: LeavePageService
  ) {
  }

}
